import React, {Component} from 'react'
import locale from '../locale'
import { Table } from 'components/UI'

class pastClassTable extends Component{
  constructor(props){
    super(props)

    this.state = {
      classList: [],
      fetching: false,
    }
  }


  componentWillReceiveProps({classList}){
    if(classList){
      this.setState({classList: classList, fetching: false})
    }
  }

  render(){
    const {showTable, classList} = this.props

    const fields = [{
      name: 'ctClass__cName',
      title: __('Class', locale),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "35%"
          }
        }
      },
    }]

    if(classList.length == 0){
      return(
        <div />
      )
    }

    if(showTable){
      return(
        <Table
          data={classList}
          fields={fields}
          className='pastClassTable'
          settingThTitle={' '}
          settingWidth={'15%'}
          settings={''}
          useMultiSelection={false}
          oneSettingPerRow={false}
          fetching={this.state.fetching}
          hideDropdownCaret={true}
          usePagination={false}

          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
        />
      )
    } else {
      return(
        <div />
      )
    }

  }
}


export default pastClassTable



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/Tables/pastClassTable.js